import ApiService from "./api.service";
export default class GiftConfigurationService extends ApiService {
    static base_url = `${super.base_url}/gift_configurations/public`;
}
